import { useAppStore } from '@/state-management/store';
import { useMemo } from 'react';

import { useShallow } from 'zustand/react/shallow';

// TODO: Hardcoded for now; will fetch from API as part of B2C-7592 Epic
const FlowerDispenseLimits = new Map([
  ['SA', 100],
  ['QLD', 100],
  ['NT', 100],
  ['NSW', 100],
  ['WA', 100],
  ['ACT', 100],
]);

const DISPENSE_LIMIT_DAY_DURATION = 30;

/**
 * Zustand selector hook that checks if the patient’s "Herb, Dried" (Flower) prescriptions
 * exceed the state-allocated dispense limit.
 * @returns boolean
 */
export const usePrescriptionDispenseLimitExceeded = () => {
  const { stateCode, medicationPadItems } = useAppStore(
    useShallow((state) => ({
      stateCode: state.patient.basicInfo.stateCode,
      medicationPadItems: state.prescriptionAssistant.prescriptionPad.medicationPadItems,
    })),
  );

  return useMemo(() => {
    const stateGramLimit = FlowerDispenseLimits.get(stateCode || '') ?? 100;
    const totalGrams = medicationPadItems
      .map((medicationPadItem) => {
        if (!medicationPadItem || !medicationPadItem.medicationPadItem) {
          return 0;
        }

        if (medicationPadItem?.filters?.get('select-formulation') !== 'Herb, Dried') {
          return 0;
        }

        const { interval, repeats, quantity, dispenseSize } = medicationPadItem.medicationPadItem;
        if (interval === undefined || repeats === undefined || quantity === undefined || dispenseSize === undefined) {
          return 0;
        }

        const sizeUsingInterval = dispenseSize * quantity * Math.floor(DISPENSE_LIMIT_DAY_DURATION / interval);
        const sizeUsingRepeats = dispenseSize * quantity * repeats;

        const smallerSize = sizeUsingInterval < sizeUsingRepeats ? sizeUsingInterval : sizeUsingRepeats;

        return smallerSize;
      })
      .reduce((grams, previousGrams) => grams + previousGrams, 0);

    return {
      isExceeded: totalGrams > stateGramLimit,
      totalGrams,
    };
  }, [medicationPadItems, stateCode]);
};
